module.exports = __webpack_public_path__ + "assets/favicons/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=assets/favicons/[name].[ext]!./src/assets/favicons/favicon.ico
// module id = BEjI
// module chunks = 1